import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
    useNavigate, useParams, Link
} from "react-router-dom";
import api from '../../../Apis';
import { useCookies } from 'react-cookie';
import { useEffect, useState } from 'react';
import Swal from "sweetalert2";
import LoadingButton from "@mui/lab/LoadingButton";
import Copyright from "../Copyright/Index";
import { useForm } from "react-hook-form";
import { Alert, Backdrop, Button, Checkbox, Dialog, DialogContent, DialogTitle, FormControlLabel, FormGroup } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import {domain_origin} from './../../../Helpers/function.js'
import parse from 'html-react-parser';
import { useTranslation } from "react-i18next";

function componentClicked() {

}
const theme = createTheme();

export default function UpdateAfterLogin() {
    const { t, i18n } = useTranslation();
    let navigate = useNavigate();
    const { uid } = useParams();
    const [cookies, setCookie] = useCookies(['is_login']);
    const {register, handleSubmit, reset, setValue, getValues} = useForm({
        defaultValues: {
            fb_id: '',
            email: '',
            username: '',
            phone: '',
            password: '',
            code: ''

        }
    });
    const [state, setState] = useState({
        error: {},
        loading_login: false,
        loading_page: true,
        user: {
            fb_id: uid,
            email: '',
            username: '',
            phone: '',
            password: '',
            password_confirmation: '',
            code: '',
            agree_term: ''
        },
        term: '',
        dialog: false,
        is_submit: false,
        access_token: ''
    })

    useEffect(() => {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                fb_id: uid,
                lang: i18n.language
            })
        };
        fetch(api.user_profile, requestOptions)
        .then(res => res.json())
        .then(
            (result) => {
                if (result.success) {
                    if (result.data.email != null && result.data.username != null && result.data.phone != null && result.data.is_phone_verified == 1) {
                        return navigate('/');
                    }
                    setState({
                        ...state,
                        user: {
                            ...state.user,
                            email: result.data.email,
                            username: result.data.username,
                            phone: result.data.phone
                        },
                        term: result.term,
                        loading_page: false
                    })
                }
            }
        )
    }, [])

    const domain = window.location.origin;

    if (domain != domain_origin ) {
        window.location.href = domain_origin + "/" + uid + '/update-login';
    }

    const confirmPhone = () => {
        setState({...state, loading_login: true})
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(state.user)
        };
        fetch(api.confirm_phone, requestOptions)
        .then(res => res.json())
        .then(
            (result) => {
                if (result.success) {
                    setState({
                        ...state,
                        loading_login: false,
                        is_submit: true
                    })
                } else {
                    setState({
                        ...state,
                        loading_login: false,
                    })
                    Swal.fire({
                        title: result.message,
                        icon: 'error',
                        timer: 2000
                    })
                }
            }
        )
        // const requestOptions = {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //     },
        //     body: JSON.stringify(data)
        // };
        // fetch(api.update_user, requestOptions)
        // .then(res => res.json())
        // .then(
        //     (result) => {
        //         if (result.success) {
        //             setState({...state, is_submit: true, access_token: result.access_token})
        //             // let date = new Date();
        //             // date.setTime(date.getTime() + result.expires_in * 1000);
        //             // setCookie('is_login', result.access_token, { path: '/', expires: date, domain: '.' + result.domain});
        //             /**
        //              * Khởi tạo dispatch để chuẩn bị bắn dữ liệu lên redux
        //              * Tạo 1 action với hàm profile trong UserAction để trả về payload với 1 object mới
        //              */
        //             // const action = profile({
        //             //     name: result.user.full_name,
        //             //     email: result.user.email,
        //             //     username: result.user.username
        //             // })
        //             //dispatch(action);
        //             // window.location.href = result.url_redirect + 'dashboard';
        //             //return navigate('/dashboard');
        //         } else {
        //             if (result.type == 'validate') {
        //                 setState({
        //                     ...state,
        //                     error: result.errors,
        //                     loading_login: false,
        //                 })
        //             } else if (result.type == 'lose') {
        //                setState({
        //                    ...state,
        //                    error: {},
        //                    loading_login: false
        //                })
        //                Swal.fire({
        //                    title: result.message,
        //                    icon: 'error',
        //                    timer: 2000
        //                })
        //             }
        //         }
        //     }
        // )
    };

    const verifyPhone = () => {
        setState({...state, loading_login: true})
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                fb_id: uid,
                code: state.user.code
            })
        };
        fetch(api.verify_phone, requestOptions)
        .then(res => res.json())
        .then(
            (result) => {
                if (result.success) {
                    let date = new Date();
                    date.setTime(date.getTime() + result.expires_in * 1000);
                    setCookie('is_login', result.access_token, { path: '/', expires: date, domain: '.' + result.domain});
                    window.location.href = result.url_redirect + 'dashboard';
                } else {
                    setState({
                        ...state,
                        loading_login: false,
                    })
                    Swal.fire({
                        title: result.message,
                        icon: 'error',
                        timer: 2000
                    })
                }
            }
        )
    }

    return (
        <ThemeProvider theme={theme}>
            {
                state.loading_page
                ?
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={state.loading_page}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
                :
                <Container component="main" maxWidth="xs">
                    <CssBaseline />
                    <Box
                        sx={{
                            marginTop: 8,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    >
                        {/* <img src={`https://${ process.env.REACT_APP_DOMAIN }/assets/img/logo/logo.png`} style={{width: '50%'}} className='logo'></img>
                        <br></br> */}
                        {
                            state.is_submit
                            ?
                            <Typography component="p" variant="p" sx={{
                                marginTop: "10px"
                            }}>
                                Tin nhắn có mã xác thực 6 số đã được gửi đến <b>Zalo</b> theo số điện <b>{state.user.phone}</b>. Hãy nhập lại mã xác thực để xác nhận số điện thoại của bạn
                            </Typography>
                            :
                            <Typography component="h5" variant="h5" sx={{
                                marginTop: "10px",
                                textAlign: "center"
                            }}>
                               {t("auth.updateInformation")}
                            </Typography>
                        }
                        <br></br>
                        <Alert severity="warning">
                            Vui lòng liên hệ <b>0963.108.271</b> nếu không xác thực được số điện thoại.
                        </Alert>
                        {
                            state.is_submit
                            ?
                            <Box
                                component="form"
                                onSubmit={handleSubmit(verifyPhone)}
                                noValidate
                                sx={{ mt: 1 }}
                            >
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    autoComplete="off"
                                    value={state.user.code}
                                    onChange={(e) => setState({...state, user: {...state.user, code: e.target.value}})}
                                />
                                <LoadingButton loading={state.loading_login}
                                    type="submit"
                                    fullWidth
                                    className="text-transform"
                                    variant="contained"
                                    size="large"
                                    sx={{ mt: 3, mb: 2 }}
                                >
                                    Xác nhận
                                </LoadingButton>
                                <Button onClick={() => setState({...state, is_submit: false})} className="text-transform" fullWidth color='inherit' variant="contained" size="large"
                                    sx={{ mb: 2 }}>Quay lại</Button>
                            </Box>
                            :
                            <Box
                                component="form"
                                onSubmit={handleSubmit(confirmPhone)}
                                noValidate
                                sx={{ mt: 1 }}
                            >
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="email"
                                    label="Email"
                                    autoComplete="off"
                                    name="email"
                                    value={state.user.email}
                                    onChange={(e) => setState({...state, user: {...state.user, email: e.target.value}})}
                                    helperText={state.error.email?.message}
                                    error={state.error.email?.status}
                                    InputLabelProps={{ shrink: true }}
                                />
                                <TextField
                                    margin="normal"
                                    required
                                    value={state.user.username}
                                    fullWidth
                                    id="email"
                                    label="Username"
                                    onChange={(e) => setState({...state, user: {...state.user, username: e.target.value}})}
                                    autoComplete="off"
                                    name="username"
                                    helperText={state.error.username?.message}
                                    error={state.error.username?.status}
                                />
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    value={state.user.phone}
                                    onChange={(e) => setState({...state, user: {...state.user, phone: e.target.value}})}
                                    id="email"
                                    label={t("common.label.phoneNumber")}
                                    name="phone"
                                    helperText={state.error.phone?.message || "Yêu cầu số điện thoại đã đăng ký Zalo"}
                                    error={state.error.phone?.status}
                                />
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    name="password"
                                    value={state.user.password}
                                    onChange={(e) => setState({...state, user: {...state.user, password: e.target.value}})}
                                    label={t("auth.password")}
                                    type="password"
                                    id="password"
                                    helperText={state.error.password?.message}
                                    error={state.error.password?.status}
                                    autoComplete="off"
                                />
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    value={state.user.password_confirmation}
                                    name="password_confirmation"
                                    label={t("auth.confirmPassword")}
                                    type="password"
                                    id="password"
                                    autoComplete="off"
                                    onChange={(e) => setState({...state, user: {...state.user, password_confirmation: e.target.value}})}
                                />
                                <FormGroup>
                                    <FormControlLabel helperText={state.error.policy?.message}
                                    error={state.error.policy?.status} control={<Checkbox defaultChecked onChange={(e) => {
                                        setState({...state, user: {...state.user, agree_term: e.target.checked}})
                                      }} />} label={t("auth.agreeTerms")} />
                                </FormGroup>
                                <p className="m-b-0 m-t-0">
                                    <a onClick={() => setState({...state, dialog: true})} className="cursor">{t("auth.termsDetails")}</a>
                                </p>
                                <LoadingButton loading={state.loading_login}
                                    className="text-transform"
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    size="large"
                                    sx={{ mt: 3, mb: 2 }}
                                >
                                    Xác nhận số điện thoại
                                </LoadingButton>
                            </Box>
                        }
                    </Box>
                    <Copyright sx={{ mt: 8, mb: 4 }} />
                </Container>
            }
            <Dialog open={state.dialog} fullWidth="true" maxWidth='sm' onClose={() => {setState({...state, dialog: false})}}>
                <DialogTitle className="m-b-0">{t("auth.termsOfUse")}</DialogTitle>
                <DialogContent>
                    {parse(state.term.replaceAll("[app_name]", process.env.REACT_APP_NAME))}
                </DialogContent>
            </Dialog>
        </ThemeProvider>
    );
}
